// extracted by mini-css-extract-plugin
module.exports = {"container":"OrderPopup_container__1QtS6","selector":"OrderPopup_selector__14cgC","actionContainer":"OrderPopup_actionContainer__2h3Xg"};